import axios from 'axios'
import jwt from 'jsonwebtoken'
import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { RoutePath } from '../router/routesConfig'
// import { useCookies } from 'react-cookie'
// import { useDispatch } from 'react-redux'
// import { setAuthenData } from '../redux/actions/AuthenACT'
// import { ProfileDataType } from '../redux/reducers/AuthenReducer'
import useLogin, { LoginFormT, ProfileT } from '../services/authen/useLogin'
import { enc } from 'crypto-js'
import { replaceForDecryptStr } from '../utilities/encryption'

type Result = {
    meta: { copyright: string; authors: string }
    result: {
        accessToken: string
        id_token: string
    }
}

type LandingProps = {
    setLogged: any
}
export enum ParamSearchKey {}
// president = '1', // ประธาน
// secreatary = '2', // เลขา

const decodeDownloadLink = (encodedDownloadLink: string): any => {
    // const buffer = Buffer.from(encodedDownloadLink, 'base64')
    // const downloadLink = buffer.toString()
    let downloadLink = ''
    try {
        // console.log('encodedDownloadLink', encodedDownloadLink)
        // console.log('typeof encodedDownloadLink', typeof encodedDownloadLink)
        const replacedDecryptStr = replaceForDecryptStr(encodedDownloadLink)
        const encodedWord = enc.Base64.parse(replacedDecryptStr)
        // console.log('encodedWord>>>>>>', encodedWord)
        downloadLink = enc.Utf8.stringify(encodedWord)
        // console.log('downloadLink', downloadLink)
    } catch (err) {
        console.log('err', err)
    }

    return downloadLink
}

const Landing: React.FC<LandingProps> = ({ setLogged }) => {
    const history = useHistory()
    const location = useLocation()
    const { post, getProfile } = useLogin()
    React.useEffect(() => {
        checkIsLogined()
    }, [])

    const checkIsLogined = async () => {
        const accessToken = localStorage.getItem('accessToken')
        const urlParams = new URLSearchParams(location.search)
        const encodedDownloadLink = urlParams.get('download_link')

        if (accessToken) {
            const expireDate = localStorage.getItem('tokenExpireDate')
            const currentDate = new Date()

            if (expireDate && currentDate.getTime() > Number(expireDate)) {
                localStorage.clear()
                history.replace(`${RoutePath.login}?download_link=${encodedDownloadLink}`, null)
            } else {
                const profileRes = await getProfile(accessToken)
                if (profileRes && profileRes.userId) {
                    //มีการ Login แล้ว\
                    if (encodedDownloadLink) {
                        const downloadLink = decodeDownloadLink(encodedDownloadLink)
                        if (downloadLink) {
                            window.location.assign(downloadLink)
                            history.push(RoutePath.manageProject)
                        }
                    }
                } else {
                    history.replace(`${RoutePath.login}?download_link=${encodedDownloadLink}`, null)
                }
            }
        } else {
            history.replace(`${RoutePath.login}?download_link=${encodedDownloadLink}`, null)
        }
    }

    useEffect(() => {
        // const callToken = async () => {
        //     try {
        //         loadingOpen()
        //         const url = process.env.REACT_APP_GOT_ID_API
        //         const response = await axios.post<Result>(`${url}/v1/token`, { code, state })
        //         const result = response.data?.result
        //         const profile: ProfileDataType = await decodeIDToken(result.id_token, response.headers['got-pub-key'])
        //         dispatch(setAuthenData(profile))
        //         setLogged(true)
        //         setCookie('got_access_token', result.accessToken, {
        //             path: RouteName.search,
        //             domain: process.env.REACT_APP_COOKIE_DOMAIN,
        //         })
        //         loadingClose()
        //         history.push(RouteName.search)
        //     } catch (error) {
        //         setError(true)
        //         const result = error.response
        //         const code = result.data?.error?.code
        //         filterErrorMessage(code)
        //         history.push(RouteName.search)
        //         return error.response
        //     }
        // }
        // callToken()
    }, [])

    const filterErrorMessage = (code: string) => {
        // return setErrorMessage('something went wrong')
    }

    return (
        <>
            <div></div>
        </>
    )
}

export default Landing
